module.exports = __webpack_public_path__ + "assets/images/scroll-down-icon-dot.svg?v=85f5f38d";